import { AxiosError } from 'axios';
import { baseService } from 'services';
import {
  IErrorResponse,
  ISuccessResponse,
  ReliantResponse,
} from 'interface/apiInterface';
import {
  IListRepositoriesResponse,
  IListRepositoriesRequest,
  IListMyRepositoriesRequest,
  IAddRepoToOrganizationRequest,
  IDeleteRepositoryRequest,
  IGetRepositorySettingsRequest,
  IUpdateRepositorySettingsRequest,
  IListRepositoriesReliantResponse,
} from 'interface/repositoryInterface';
import {
  addRepoToOrganizationEP,
  commonError,
  deleteRepositoryEP,
  getRepositorySettingsEP,
  listMyRepositoriesEP,
  listRepositoriesEP,
  updateRepositorySettingsEP,
} from './constants';

export const addRepoToOrganization = async (
  data: IAddRepoToOrganizationRequest,
): Promise<ISuccessResponse | IErrorResponse<AxiosError>> => {
  try {
    const response = await baseService.post(addRepoToOrganizationEP, data);
    return response;
  } catch (error) {
    return commonError(error as AxiosError, true);
  }
};

export const deleteRepository = async (
  data: IDeleteRepositoryRequest,
): Promise<ISuccessResponse | IErrorResponse<AxiosError>> => {
  try {
    const response = await baseService.post(deleteRepositoryEP, data);
    return response;
  } catch (error) {
    return commonError(error as AxiosError, true);
  }
};

export const listRepositories = async (
  data: IListRepositoriesRequest,
): Promise<
  ISuccessResponse<IListRepositoriesResponse> | IErrorResponse<AxiosError>
> => {
  try {
    const response = await baseService.post(listRepositoriesEP, data);
    return response;
  } catch (error) {
    return commonError(error as AxiosError, true);
  }
};

export const listMyRepositories = async (
  data: IListMyRepositoriesRequest,
): Promise<
  ISuccessResponse<IListRepositoriesResponse> | IErrorResponse<AxiosError>
> => {
  const response = await baseService.post(listMyRepositoriesEP, data);
  return response;
};

// repository settings
export const getRepositorySettings = async (
  data: IGetRepositorySettingsRequest,
): Promise<ISuccessResponse | IErrorResponse<AxiosError>> => {
  const response = await baseService.post(getRepositorySettingsEP, data);
  return response;
};

export const updateRepositorySettings = async (
  data: IUpdateRepositorySettingsRequest,
): Promise<ISuccessResponse | IErrorResponse<AxiosError>> => {
  const response = await baseService.post(updateRepositorySettingsEP, data);
  return response;
};

export const listRepositoriesReliant = async (
  data: IListMyRepositoriesRequest,
): Promise<ReliantResponse<IListRepositoriesReliantResponse>> => {
  try {
    const response = await baseService.post<IListRepositoriesReliantResponse>(
      listRepositoriesEP,
      data,
    );
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};
